const FETCH_CUSTOMER_TIMELINE = 'FETCH_CUSTOMER_TIMELINE'

export default FETCH_CUSTOMER_TIMELINE
